const lang = {
  alpha: "{_field_}はアルファベットのみ使用できます。",
  alpha_num: "{_field_}は英数字のみ使用できます。",
  alpha_dash: "{_field_}は英数字とハイフン、アンダースコアのみ使用できます。",
  alpha_spaces: "{_field_}はアルファベットと空白のみ使用できます。",
  between: "{_field_}は{min}から{max}の間でなければなりません。",
  confirmed:
    "新しいパスワードと新しいパスワード（確認用）は同じ値で入力してください",
  digits: "{_field_}は{length}桁の数字でなければなりません。",
  dimensions:
    "{_field_}は幅{width}px、高さ{height}px以内でなければなりません。",
  email: "{_field_}は有効なメールアドレスではありません。",
  excluded: "{_field_}は不正な値です。",
  ext: "{_field_}は有効なファイル形式ではありません。",
  image: "{_field_}は有効な画像形式ではありません。",
  integer: "{_field_}は整数のみ使用できます。",
  is: "{_field_}が一致しません。",
  length: "{_field_}は{length}文字でなければなりません。",
  max_value: "{_field_}は{max}以下でなければなりません。",
  max: "{_field_}の長さに誤りがあります",
  mimes: "{_field_}は有効なファイル形式ではありません。",
  min_value: "{_field_}は{min}以上でなければなりません。",
  min: "{_field_}は{length}文字以上でなければなりません。",
  numeric: "{_field_}は半角数字で入力してください",
  oneOf: "{_field_}は有効な値ではありません。",
  regex: "{_field_}のフォーマットが正しくありません。",
  required: "{_field_}を入力してください",
  required_if: "{_field_}は必須項目です。",
  size: "{_field_}は{size}KB以内でなければなりません。",
  half_size: "{_field_}は英数字記号の組合せで入力してください",
  full_size: "{_field_}は全角で入力してください",
  full_half_size:
    "{_field_}全角{full_size}文字、半角{size}文字以内で入力してください",
  postcode: "{_field_}は無効",
  validate_tel: "{_field_}はが電話番号形式に合いません",
  mblength: "{_field_}は{min}〜{max}文字のみ入力できます",
  with_under_score: "{_field_}は英数字、_(アンダーバー)のみ使用できます。",
  number_alphabet_character: "{_field_}は英数字記号の組合せで入力してください",
  combined_two_character: "パスワードは英数字記号の組合せで入力してください",
  full_size_katakana: "{_field_}は全角カナで入力してください",
  half_size_number: "{_field_}" + " は半角数字で入力してください。",
};

export default lang;
